import i18n from '@/i18n'

const state = {
    locale: {
        flag: 'ao',
        key: 'pt-AO',
        name: 'Português (pt-AO)',
        definition: {
            calendarPickerLocale: {
                days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                monthsShort: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OCT', 'NON', 'DEZ'],
                firstDayOfWeek: 1
            }
        },
  },
  
  list: []
}

const getters = {
  currentLocale(state) {
    return state.locale
  },

  localeList(state) {
    return state.list
  }
  
}

const mutations = {
  setLocale(state, locale) {
        state.locale = locale
        document.querySelector('html').setAttribute('lang', locale.key)
        if (i18n) i18n.locale = locale.key
  },
  
  updateLocale(state, locale) {
      state.locale = locale
  },

  changeLocale(state, locale) {
    for (const loc of state.list) {
        if (loc.key === locale) {
            state.locale = loc
            if (i18n) i18n.locale = loc.key
        }
    }
  },
  
  setList(state, locale) {
    state.list = locale
  }
}

const actions = {
  updateLocale(context, locale) {
        context.commit('changeLocale', locale)
  },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
